import { createAction, props } from '@ngrx/store';
import { id } from '../interfaces/id.type';
import { ITenant } from './interfaces/tenant.interface';

export const loadPersonalTenants = createAction('[Tenant] Load Personal Tenants');

export const loadTenantsSuccess = createAction(
  '[Tenant] Load Tenants Success',
  props<{ tenants: ITenant[] }>()
);

export const loadTenantsFailure = createAction(
  '[Tenant] Load Tenants Failure',
  props<{ error: unknown }>()
);

export const selectTenant = createAction(
  '[Tenant] Select Tenant',
  props<{ tenantId: id | null }>()
);

export const selectTenantSuccess = createAction(
  '[Tenant] Select Tenant Success',
  props<{ tenantId: id | null }>()
);

export const selectTenantFailure = createAction(
  '[Tenant] Select Tenant Failure',
  props<{ error: unknown }>()
);

export const loadSelectedTenant = createAction('[Tenant] Load Selected Tenant');

export const loadSelectedTenantFailure = createAction(
  '[Tenant] Load Selected Tenant Failure',
  props<{ error: unknown }>()
);
